/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Accessdataroom_Accessbutton4Inputs */

const en_coinvestments_accessdataroom_accessbutton4 = /** @type {(inputs: Coinvestments_Accessdataroom_Accessbutton4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access data room`)
};

/**
* | output |
* | --- |
* | "Access data room" |
*
* @param {Coinvestments_Accessdataroom_Accessbutton4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_accessdataroom_accessbutton4 = /** @type {((inputs?: Coinvestments_Accessdataroom_Accessbutton4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Accessdataroom_Accessbutton4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_accessdataroom_accessbutton4(inputs)
});
export { coinvestments_accessdataroom_accessbutton4 as "coInvestments_accessDataRoom_accessButton" }